import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-header',
	standalone: false,
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	@Input() showBackBtn: boolean = false;
	@Input() showLangWithAddress: boolean = false;
	@Input() transparent: boolean = false;

	@Output() back = new EventEmitter<void>();

	version = environment.version;

	private repositoryService = inject(RepositoryService);
	private translate = inject(TranslateService);
	address: string = this.repositoryService.venue?.address ?? '';
	flagSrc: string = this.flagSrcForLang(this.currentLang);
	private destroyRef = inject(DestroyRef);

	constructor() {
		this.repositoryService.venueObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(venue => {
			this.address = venue?.address ?? '';
		});
		this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
			this.flagSrc = this.flagSrcForLang(this.currentLang);
		});
	}

	onBackClick() {
		this.back.emit();
	}

	// Toggles the UI language between German and English and persists the choice.
	onLangClick() {
		const next = this.currentLang === 'de' ? 'en' : 'de';
		this.translate.use(next);
		try {
			localStorage.setItem('lang', next);
		} catch (e) {}
	}

	private get currentLang(): string {
		return this.translate.currentLang === 'en' ? 'en' : 'de';
	}

	private flagSrcForLang(lang: string): string {
		return lang === 'en' ? '/assets/icon/flags/en.svg' : '/assets/icon/flags/de.svg';
	}
}
